import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/language-helper';
import {renderMarkdown} from 'helpers/text-helper';
import {getPlayerModuleSessionData} from 'helpers/module-helper';
import {getModuleMaxPoints, getNumberOfFilledStars} from 'helpers/points-helper';
import {modulesData} from 'data/modules-data';
import {playerUiTexts} from 'data/ui-texts/player-ui-texts';
import Button from 'components/ui/button/button';
import './gameover.scss';

const Gameover = (props) => {
	const {
		languageId, 
		moduleId,
		deviceInfo,
		playerData,
		handleGoToGamePage,
		startNewSessionInModule,
		handleGoToTask
	} = props;

	/* Loading status */
	const [isLoading, setIsLoading] = useState(false);

	/* Get text */
	const playerModuleSession = getPlayerModuleSessionData(playerData, moduleId);
	const points = (playerModuleSession ? playerModuleSession.points : 0);
	const maxPoints = getModuleMaxPoints(moduleId);
	const filledStars = useRef(getNumberOfFilledStars(points, maxPoints));
	const moduleData = modulesData.find((m) => {return m.id === moduleId;});
	let gameoverText = null;
	if (moduleData) {
		gameoverText = (filledStars.current >= 3
			? getText(moduleData.gameOverWin, languageId)
			: getText(moduleData.gameOverLose, languageId)
		);
	}

	/**
	 * Start new session
	 */
	const handleStartNewSession = () => {
		if (isLoading) return;

		setIsLoading(true);
		startNewSessionInModule(moduleId).then((response) => {
			if (response.status === 'success') {				
				if (moduleData && moduleData.tasks && moduleData.tasks.length > 0) {
					handleGoToTask(moduleData.tasks[0].id);
				} else {
					handleGoToGamePage('landing');
				}
			} else {
				handleGoToGamePage('landing');
			}
		});
	};

	return (
		<div className={'Gameover ' + deviceInfo.orientation}>
			<div className="Gameover-blackboard">
				{renderMarkdown(gameoverText)}
			</div>
			<div className="Gameover-buttons">
				<div className="Gameover-homeBtn">
					<Button 
						classes={['blueDark', 'fullHeight']}
						text={getText(playerUiTexts.finishBtn, languageId)}
						onClick={() => {handleGoToGamePage('landing');}}
					/>
				</div>
				{filledStars.current < 3 && <div className="Gameover-tryAgainBtn">
					<Button 
						isLoading={isLoading}
						classes={['blueDark', 'fullHeight']}
						text={getText(playerUiTexts.tryAgain, languageId)}
						onClick={() => {handleStartNewSession();}}
					/>
				</div>}
			</div>
		</div>
	);
};

Gameover.propTypes = {
	languageId: PropTypes.string.isRequired,
	moduleId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	playerData: PropTypes.object.isRequired,
	handleGoToGamePage: PropTypes.func.isRequired,
	startNewSessionInModule: PropTypes.func.isRequired,
	handleGoToTask: PropTypes.func.isRequired
};

export default Gameover;
